<template>
  <div id="hours-container" class="mt-5" :class="{ notEdit: !isEdit }">
    <div id="hours-header">
      <h3>{{ $t("coworking-info.hours.title") }}*</h3>
    </div>
    <div>
      <div class="row d-flex align-items-center my-3">
        <div class="col-1">
          <label class="control-hours control-checkbox-hours mb-0">
            {{ $t("utils.days.monday") }}
            <input v-model="info.monday" type="checkbox" :disabled="!isEdit" />
            <div class="control_indicator-hours"></div>
          </label>
        </div>

        <div class="form-hours col-11">
          <label for="open">{{ $t("coworking-info.hours.title") }}</label>
          <input
            type="time"
            class="input-hours"
            id="open"
            :disabled="!isEdit"
            v-model="info.hours.monday.start"
          />
          <label for="close">{{ $t("utils.input-label.closing-hours") }}</label>
          <input
            type="time"
            class="input-hours"
            id="close"
            :disabled="!isEdit"
            v-model="info.hours.monday.end"
          />
        </div>
      </div>

      <div class="row d-flex align-items-center my-3">
        <div class="col-1">
          <label class="control-hours control-checkbox-hours mb-0">
            {{ $t("utils.days.tuesday") }}
            <input v-model="info.tuesday" type="checkbox" :disabled="!isEdit" />
            <div class="control_indicator-hours"></div>
          </label>
        </div>

        <div class="form-hours col-11">
          <label for="open">{{ $t("coworking-info.hours.title") }}</label>
          <input
            type="time"
            class="input-hours"
            id="open"
            :disabled="!isEdit"
            v-model="info.hours.tuesday.start"
          />
          <label for="close">{{ $t("utils.input-label.closing-hours") }}</label>
          <input
            type="time"
            class="input-hours"
            id="close"
            :disabled="!isEdit"
            v-model="info.hours.tuesday.end"
          />
        </div>
      </div>

      <div class="row d-flex align-items-center my-3">
        <div class="col-1">
          <label class="control-hours control-checkbox-hours mb-0">
            {{ $t("utils.days.wednesday") }}
            <input
              v-model="info.wednesday"
              type="checkbox"
              :disabled="!isEdit"
            />
            <div class="control_indicator-hours"></div>
          </label>
        </div>

        <div class="form-hours col-11">
          <label for="open">{{ $t("coworking-info.hours.title") }}</label>
          <input
            type="time"
            class="input-hours"
            id="open"
            :disabled="!isEdit"
            v-model="info.hours.wednesday.start"
          />
          <label for="close">{{ $t("utils.input-label.closing-hours") }}</label>
          <input
            type="time"
            class="input-hours"
            id="close"
            :disabled="!isEdit"
            v-model="info.hours.wednesday.end"
          />
        </div>
      </div>

      <div class="row d-flex align-items-center my-3">
        <div class="col-1">
          <label class="control-hours control-checkbox-hours mb-0">
            {{ $t("utils.days.thursday") }}
            <input
              v-model="info.thursday"
              type="checkbox"
              :disabled="!isEdit"
            />
            <div class="control_indicator-hours"></div>
          </label>
        </div>

        <div class="form-hours col-11">
          <label for="open">{{ $t("coworking-info.hours.title") }}</label>
          <input
            type="time"
            class="input-hours"
            id="open"
            :disabled="!isEdit"
            v-model="info.hours.thursday.start"
          />
          <label for="close">{{ $t("utils.input-label.closing-hours") }}</label>
          <input
            type="time"
            class="input-hours"
            id="close"
            :disabled="!isEdit"
            v-model="info.hours.thursday.end"
          />
        </div>
      </div>

      <div class="row d-flex align-items-center my-3">
        <div class="col-1">
          <label class="control-hours control-checkbox-hours mb-0">
            {{ $t("utils.days.friday") }}
            <input v-model="info.friday" type="checkbox" :disabled="!isEdit" />
            <div class="control_indicator-hours"></div>
          </label>
        </div>

        <div class="form-hours col-11">
          <label for="open">{{ $t("coworking-info.hours.title") }}</label>
          <input
            type="time"
            class="input-hours"
            id="open"
            :disabled="!isEdit"
            v-model="info.hours.friday.start"
          />
          <label for="close">{{ $t("utils.input-label.closing-hours") }}</label>
          <input
            type="time"
            class="input-hours"
            id="close"
            :disabled="!isEdit"
            v-model="info.hours.friday.end"
          />
        </div>
      </div>

      <div class="row d-flex align-items-center my-3">
        <div class="col-1">
          <label class="control-hours control-checkbox-hours mb-0">
            {{ $t("utils.days.saturday") }}
            <input
              v-model="info.saturday"
              type="checkbox"
              :disabled="!isEdit"
            />
            <div class="control_indicator-hours"></div>
          </label>
        </div>

        <div class="form-hours col-11">
          <label for="open">{{ $t("coworking-info.hours.title") }}</label>
          <input
            type="time"
            class="input-hours"
            id="open"
            :disabled="!isEdit"
            v-model="info.hours.saturday.start"
          />
          <label for="close">{{ $t("utils.input-label.closing-hours") }}</label>
          <input
            type="time"
            class="input-hours"
            id="close"
            :disabled="!isEdit"
            v-model="info.hours.saturday.end"
          />
        </div>
      </div>

      <div class="row d-flex align-items-center my-3">
        <div class="col-1">
          <label class="control-hours control-checkbox-hours mb-0">
            {{ $t("utils.days.sunday") }}
            <input v-model="info.sunday" type="checkbox" :disabled="!isEdit" />
            <div class="control_indicator-hours"></div>
          </label>
        </div>

        <div class="form-hours col-11">
          <label for="open">{{ $t("coworking-info.hours.title") }}</label>
          <input
            type="time"
            class="input-hours"
            id="open"
            :disabled="!isEdit"
            v-model="info.hours.sunday.start"
          />
          <label for="close">{{ $t("utils.input-label.closing-hours") }}</label>
          <input
            type="time"
            class="input-hours"
            id="close"
            :disabled="!isEdit"
            v-model="info.hours.sunday.end"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info", "isEdit"],
  methods: {
    setIsCheckedDay() {
      if (
        !this.$props.info.monday &&
        !this.$props.info.tuesday &&
        !this.$props.info.wednesday &&
        !this.$props.info.thursday &&
        !this.$props.info.friday &&
        !this.$props.info.saturday &&
        !this.$props.info.sunday
      ) {
        return (this.$props.info.isCheckedDay = true);
      } else {
        return (this.$props.info.isCheckedDay = false);
      }
    }
  },
  updated() {
    this.setIsCheckedDay();
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";

#hours-container {
  width: 750px;

  &.notEdit {
    .control-hours {
      input {
        &:checked ~ .control_indicator-hours {
          background: #04b900;
          opacity: 0.6;
          pointer-events: none;
        }

        &:not(checked) ~ .control_indicator-hours {
          background: #111112;
          opacity: 0.6;
          pointer-events: none;
        }
      }
    }
  }

  #hours-header {
    h3 {
      font-family: $inter;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      color: #767676;
    }
  }

  .form-hours {
    & > label {
      top: -22px;
      left: 150px;
      position: relative;
      background-color: #e5e5e5;
      padding: 0px 5px 0px 5px;
      font-size: 0.9em;
      font-family: $inter;
      font-style: normal;
      font-weight: normal;
    }
  }

  .add-hours {
    position: relative;
    top: -102px;
    left: 600px;
    border: none;
    background-color: #e5e5e5;
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    margin-left: 50px;
  }

  .input-hours {
    padding-left: 20px;
    height: 45px;
    width: 200px;
    background-color: #e5e5e5;
    border: 2px solid #c4c4c4;
    box-sizing: border-box;
    border-radius: 6px;
    font-family: $inter;
    font-style: normal;
    font-weight: normal;
    margin-right: -50px;
  }

  input[type="time"]::-webkit-calendar-picker-indicator {
    background: none;
  }

  input[type="time"]:focus {
    border: #7e4ee2;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #7e4ee2;
  }

  .control-hours {
    display: block;
    position: relative;
    padding-left: 2rem;
    margin-bottom: 0.5rem;
    padding-top: 0.2rem;
    cursor: pointer;
    font-family: $worksans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #000000;

    input {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }
  }

  .control_indicator-hours {
    position: absolute;
    top: 2px;
    left: 0;
    height: 22px;
    width: 22px;
    background: #c4c4c4;
    box-sizing: border-box;
    border-radius: 3px;
    z-index: 2 !important;

    &:after {
      box-sizing: unset;
      content: "";
      position: absolute;
      display: none;
    }
  }

  .control-checkbox-hours {
    input:disabled ~ .control_indicator-hours:after {
      border-color: none;
    }
  }

  .opening-container {
    margin-top: -60px;
  }

  .border {
    border: none !important;
    margin-bottom: 10px;
    box-shadow: none;
  }

  .control {
    display: block;
    position: relative;
    padding-left: 2rem;
    margin-bottom: 0.5rem;
    padding-top: 0.2rem;
    cursor: pointer;
    font-family: $worksans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #000000;
  }

  .control_indicator {
    position: absolute;
    top: 2px;
    left: 0;
    height: 22px;
    width: 22px;
    background: #c4c4c4;
    box-sizing: border-box;
    border-radius: 3px;

    &:after {
      box-sizing: unset;
      content: "";
      position: absolute;
      display: none;
    }
  }

  .control input:checked ~ .control_indicator:after {
    display: block;
  }

  .control-checkbox input:disabled ~ .control_indicator:after {
    border-color: none;
  }

  .control-hours input:checked ~ .control_indicator-hours {
    background: #7e4ee2;
  }

  .control-hours input:hover ~ .control_indicator-hours {
    border: none;
  }

  .control-hours input:disabled ~ .control_indicator-hours {
    background: #111112;
    opacity: 0.6;
    pointer-events: none;
  }

  .control_indicator-hours:after {
    box-sizing: unset;
    content: "";
    position: absolute;
    display: none;
  }

  .control-hours input:checked ~ .control_indicator-hours:after {
    display: block;
  }

  .control-checkbox-hours .control_indicator-hours:after {
    left: 8px;
    top: 5px;
    width: 3px;
    height: 7px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  .control-checkbox-hours input:disabled ~ .control_indicator-hours:after {
    border-color: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/info/components/Hours.vue